//import { useEffect } from 'react';
export enum EListener {
  clearSalesChannel = 'clearSalesChannel',
}

const useListeners = () => {
  // useEffect(() => {
  //   document.addEventListener(
  //     EListener.clearSalesChannel,
  //     clearSaleChannelListener,
  //   );
  //   return () => {
  //     document.removeEventListener(
  //       EListener.clearSalesChannel,
  //       clearSaleChannelListener,
  //     );
  //   };
  // }, []);
};
export { useListeners };

// import { useClearSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
// const clearSaleChannelListener = () => {
//   useClearSalesChannel();
// };
